import { FinanceAccountInitializationContainer } from '../../../containers';

export const FinanceAccountInitialization = () => {
  return <FinanceAccountInitializationContainer />;
};
